import { Icon } from '@antimatterhq/ui/components/icon';
import { cn } from '@/lib/utils';
import { exhaustiveMatchingGuard } from '@/utils/util';
import { DatasourceUpgradeFieldStatus } from '@/lib/datasource/upgrade/datasourceUpgrade.types';

export type DatasourceUpgradeStatusIconProps = {
  status?: DatasourceUpgradeFieldStatus;
  className?: string;
  hideUnapplied?: boolean;
};

export const DatasourceUpgradeStatusIcon = ({
  status,
  className,
  hideUnapplied,
}: DatasourceUpgradeStatusIconProps) => {
  if (!status) {
    return null;
  }

  switch (status) {
    case 'conflicted':
      return (
        <Icon
          icon="lucide:octagon-alert"
          className={cn('text-red-600 dark:text-red-500', className)}
          data-testid="datasource-upgrade-status-icon-conflicted"
        />
      );
    case 'unapplied':
      if (hideUnapplied) {
        return null;
      }
      return (
        <Icon
          icon="radix-icons:update"
          className={cn('text-yellow-600 dark:text-yellow-500', className)}
          data-testid="datasource-upgrade-status-icon-unapplied"
        />
      );
    case 'confirmed':
      return (
        <Icon
          icon="lucide:check"
          className={cn('text-green-600 dark:text-green-500', className)}
          data-testid="datasource-upgrade-status-icon-confirmed"
        />
      );
    case 'unchanged':
      return null;
    default:
      exhaustiveMatchingGuard(status);
  }
};
